'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _require = require('lodash'),
    isNil = _require.isNil,
    getIn = _require.get;

var _require2 = require('../../constants/folderMonitorInitializationStatuses'),
    OK = _require2.OK;

/**
 * Determine folder monitor roll-up state based on cloud initialization status (initializationStatus) and device
 * status (deviceStatus) attributes using the following rules:
 *
 *   1. If initialization status is not present, default to OK.
 *   2. Initialization status takes precedence over devices status when device status is not present or is reporting OK.
 *   3. Device status takes precedence over initialization status when device status is reporting an error.
 */


var determineMonitorStatus = function determineMonitorStatus(_ref) {
    var deviceStatus = _ref.deviceStatus,
        deviceEventError = _ref.deviceEventError,
        initializationStatus = _ref.initializationStatus,
        initializationEventError = _ref.initializationEventError;

    var state = void 0;
    var error = void 0;
    var errorMessage = void 0;

    if (isNil(initializationStatus)) {
        // When initialization status is not present, default to OK status. This is for folder monitors that predate the
        // deployment of the cloud code that populates initialization status attributes when retrying folder monitor
        // creation.
        state = OK;
    } else if (isNil(deviceStatus) || deviceStatus === OK) {
        // When device status is not present (because the Jet server has not reported a health check event) or has an
        // OK status, use the initialization status to determine the overall folder monitor status.
        state = initializationStatus;
        error = getIn(initializationEventError, 'code');
        errorMessage = getIn(initializationEventError, 'message');
    } else {
        // Otherwise use the device error status as the overall state. We are accepting that if the device was in an
        // error state, we will show an error state until both the initialization event and the first health check event
        // is processed in the cloud. This should be a small time window.
        state = deviceStatus;
        error = getIn(deviceEventError, 'code');
        errorMessage = getIn(deviceEventError, 'message');
    }

    return _extends({
        state: state
    }, error && { error: error }, errorMessage && { errorMessage: errorMessage });
};

var filterAttributesForPartner = function filterAttributesForPartner(_ref2) {
    var monitorId = _ref2.monitorId,
        accountId = _ref2.accountId,
        serviceId = _ref2.serviceId,
        deviceStatus = _ref2.deviceStatus,
        deviceEventError = _ref2.deviceEventError,
        lastDeviceEventReceivedOn = _ref2.lastDeviceEventReceivedOn,
        initializationStatus = _ref2.initializationStatus,
        initializationEventError = _ref2.initializationEventError,
        lastInitializationEventTime = _ref2.lastInitializationEventTime,
        status = _ref2.status;
    return _extends({
        monitorId: monitorId,
        accountId: accountId,
        serviceId: serviceId
    }, deviceStatus && { deviceStatus: deviceStatus }, deviceEventError && { deviceEventError: { code: deviceEventError.code } }, lastDeviceEventReceivedOn && { lastDeviceEventReceivedOn: lastDeviceEventReceivedOn }, initializationStatus && { initializationStatus: initializationStatus }, initializationEventError && { initializationEventError: { code: initializationEventError.code } }, lastInitializationEventTime && { lastInitializationEventTime: lastInitializationEventTime }, {

        status: _extends({ state: status.state }, status.error && { error: status.error })
    });
};

// eslint-disable no-unused-vars
var mapFolderMonitor = function mapFolderMonitor(userAccountId) {
    return function (_ref3) {
        var monitorId = _ref3.monitorId,
            accountId = _ref3.accountId,
            serviceId = _ref3.serviceId,
            deviceId = _ref3.deviceId,
            deviceStatus = _ref3.deviceStatus,
            deviceEventError = _ref3.deviceEventError,
            lastDeviceEventReceivedOn = _ref3.lastDeviceEventReceivedOn,
            initializationStatus = _ref3.initializationStatus,
            initializationEventError = _ref3.initializationEventError,
            lastInitializationEventTime = _ref3.lastInitializationEventTime,
            url = _ref3.url,
            createdOn = _ref3.createdOn,
            lastModifiedOn = _ref3.lastModifiedOn,
            createdBy = _ref3.createdBy,
            createdByAuthId = _ref3.createdByAuthId,
            lastModifiedBy = _ref3.lastModifiedBy,
            lastModifiedByAuthId = _ref3.lastModifiedByAuthId;

        var status = determineMonitorStatus({
            deviceStatus: deviceStatus,
            deviceEventError: deviceEventError,
            initializationStatus: initializationStatus,
            initializationEventError: initializationEventError
        });

        var mappedFolderMonitor = _extends({
            monitorId: monitorId,
            accountId: accountId,
            serviceId: serviceId,
            deviceId: deviceId
        }, deviceStatus && { deviceStatus: deviceStatus }, deviceEventError && { deviceEventError: deviceEventError }, lastDeviceEventReceivedOn && { lastDeviceEventReceivedOn: lastDeviceEventReceivedOn }, initializationStatus && { initializationStatus: initializationStatus }, initializationEventError && { initializationEventError: initializationEventError }, lastInitializationEventTime && { lastInitializationEventTime: lastInitializationEventTime }, {
            url: url,
            createdOn: createdOn,
            lastModifiedOn: lastModifiedOn
        }, createdBy && { createdBy: createdBy }, createdByAuthId && { createdByAuthId: createdByAuthId }, lastModifiedBy && { lastModifiedBy: lastModifiedBy }, lastModifiedByAuthId && { lastModifiedByAuthId: lastModifiedByAuthId }, {
            status: status
        });

        if (userAccountId !== accountId) {
            mappedFolderMonitor = filterAttributesForPartner(mappedFolderMonitor);
        }

        return mappedFolderMonitor;
    };
};

module.exports = { mapFolderMonitor: mapFolderMonitor };